import decode from 'jwt-decode';
import moment from 'moment';
import {isOpera} from '../BrowserContext';


const AUTH_TOKEN_KEY = 'id_token';
const AUTH_ROLES_KEY = 'roles';
const AUTH_CONFIG_KEY = 'config';
const LOGOUT_KEY = 'log_out';
export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        if (domain !== null && domain !== undefined) {
            this.domain = domain;
        } else {
            this.domain = process.env.REACT_APP_BACKEND_URL; // API server domain
        }
        this.fetch = this.fetch.bind(this);
        this.setUiMethods = this.setUiMethods.bind(this);
        // eslint-disable-next-line no-extend-native
        Date.prototype.toJSON = function () {
            return moment(this).format('YYYY-MM-DDTHH:mm:ssZ');
        };
        this.counter = 0;
        this.path = '';
        this.login = this.login.bind(this);
        this.getProfile = this.getProfile.bind(this);
    }

    setUiMethods(blockUi, unblockUi) {
        this.blockUi = blockUi;
        this.unblockUi = unblockUi;
    }

    fetch(url, options, headers) {
        const method = options !== undefined ? options.method : undefined;
        // performs api calls sending the required authentication headers
        if (headers === null || headers === undefined) {
            headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            };
        }
        if (this.loggedIn()) {
            headers['Authorization'] = this.getToken();
        }
        if (method === 'POST' || method === 'PUT') {
            this.counter += 1;
            if (this.blockUi !== undefined) {
                this.blockUi();
            }
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                headers,
                ...options,
            })
                .then((response) => this.parseJSON(response, headers))
                .then((response) => {
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        response.ok &&
                        (headers === undefined || headers.accept === 'application/json' || headers.Accept === 'application/json')
                    ) {
                        return resolve(response.json, response.status);
                    } else if (response.ok) {
                        return resolve(response.body);
                    }
                    // extract the error from the server's json
                    return reject(response.json);
                })
                .catch((error) => {
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        error !== undefined &&
                        error !== null &&
                        error.message !== undefined &&
                        error.message !== null &&
                        (error.message.includes('NetworkError when attempting to fetch resource') ||
                            error.message.includes('Failed to fetch'))
                    ) {
                        error.message = 'komunikacji z serwerem podczas pobierania danych.';
                    }
                    reject(error);
                });
        });
    }

    parseJSON(response, headers) {
        if (response.status) {
            return new Promise((resolve, reject) => {
                if (headers === undefined || headers.accept === 'application/json' || headers.Accept === 'application/json') {
                    response.json().then(
                        (json) => {
                            resolve({
                                status: response.status,
                                ok: response.ok,
                                json,
                            });
                        },
                        (reason) => {
                            reject({
                                status: response.status,
                                ok: response.ok,
                                json: {message: reason},
                            });
                        }
                    );
                } else {
                    resolve({
                        status: response.status,
                        ok: response.ok,
                        body: response.body,
                    });
                }
            });
        } else {
            return new Promise((resolve) =>
                resolve({
                    status: response.status,
                    ok: response.ok,
                    json: {message: ''},
                })
            );
        }
    }

    login(username, password) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/auth`, {
            method: 'POST',
            body: JSON.stringify({
                username,
                password,
                //cbkId: selectedUserCbkId, to bylo w eboku, a w moya cena bez cbk
            }),
        }).then((res) => {
            this.setToken(res.token); // Setting the token in localStorage
            this.setAppConfig(res.appConfig);
            this.setRoles(res.roles)
            return Promise.resolve(res);
        });
    }

    acceptTerms(contractTermsId, token) {
        // Get a token from api server using the fetch api
        return this.fetch(
            `${this.domain}/account/accept-contract-terms`,
            {
                method: 'POST',
                body: JSON.stringify({
                    contractTermsId,
                }),
            },
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
                Authorization: token,
            }
        ).then((res) => {
            this.setToken(res.token); // Setting the token in localStorage
            return Promise.resolve(res);
        });
    }

    refresh() {
        //ograniczenie, żeby za często nie pukać po token
        const now = moment();
        const tokenUpdateTime = localStorage.getItem('tokenUpdateTime');
        if (tokenUpdateTime) {
            const tokenUpdateTimeMoment = moment(tokenUpdateTime, 'YYYY-MM-DD HH:mm:ss');
            if (tokenUpdateTimeMoment.isValid()) {
                const maxTime = tokenUpdateTimeMoment.add(5, 'seconds');
                if (now.isBefore(maxTime)) {
                    this.jwtRefreshBlocked = true;
                    return Promise.resolve({});
                } else {
                    localStorage.setItem('tokenUpdateTime', now.format('YYYY-MM-DD HH:mm:ss'));
                }
            }
        }

        return this.fetch(`${this.domain}/refresh`, {
            method: 'GET',
        }).then((res) => {
            this.setToken(res.token); // Setting the token in localStorage
            return Promise.resolve(res);
        });
    }

    logout() {
        // Get a token from api server using the fetch api

        localStorage.removeItem(AUTH_TOKEN_KEY);
        sessionStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(AUTH_ROLES_KEY);
        sessionStorage.removeItem(AUTH_ROLES_KEY);
        localStorage.removeItem(AUTH_CONFIG_KEY);
        sessionStorage.removeItem(AUTH_CONFIG_KEY);

        localStorage.removeItem('i18nextLng');
        sessionStorage.removeItem('i18nextLng');
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken(); // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token); // handwaiving here
    }

    isTokenValidForRefresh() {
        const token = this.getToken();
        try {
            const decoded = decode(token);
            let seconds = moment().diff(new Date(decoded.created), 'seconds');
            if (seconds > 30) {
                // Checking if token is expired. N
                return true;
            } else {
                return false;
            }
        } catch (err) {
            return false;
        }
    }
    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
                // Checking if token is expired. N
                return true;
            } else return false;
        } catch (err) {
            return false;
        }
    }
    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem(AUTH_TOKEN_KEY, idToken);
        sessionStorage.setItem(AUTH_TOKEN_KEY, idToken);
    }

    setAppConfig(appConfig) {
        localStorage.setItem(AUTH_CONFIG_KEY, JSON.stringify(appConfig));
        sessionStorage.setItem(AUTH_CONFIG_KEY, JSON.stringify(appConfig));
    }
    setRoles(roles) {
        localStorage.setItem(AUTH_ROLES_KEY, JSON.stringify(roles));
        sessionStorage.setItem(AUTH_ROLES_KEY, JSON.stringify(roles));
    }

    getToken() {
        if (this.canSetTokenFromSession()) {
            this.setFromSessionStorageToLocalStorageToken();
        }
        return localStorage.getItem(AUTH_TOKEN_KEY);
    }

    getAppConfig() {
        return JSON.parse(localStorage.getItem(AUTH_CONFIG_KEY));
    }

    getRoles() {
        const roles = JSON.parse(localStorage.getItem(AUTH_ROLES_KEY));
        if (roles && Array.isArray(roles) && roles.every(element => typeof element === 'string')) {
            return roles;
        } else {
            return [];
        }
    }

    canSetTokenFromSession() {
        return localStorage.getItem(AUTH_TOKEN_KEY) === null && localStorage.getItem(LOGOUT_KEY) !== LOGOUT_KEY;
    }
    setFromSessionStorageToLocalStorageToken() {
        const idToken = sessionStorage.getItem(AUTH_TOKEN_KEY);        
        if (idToken !== null && !isOpera()) {
            localStorage.setItem(AUTH_TOKEN_KEY, idToken);
            const appConfig = sessionStorage.getItem(AUTH_CONFIG_KEY);
            const roles = sessionStorage.getItem(AUTH_ROLES_KEY);
            localStorage.setItem(AUTH_CONFIG_KEY, appConfig);
            localStorage.setItem(AUTH_ROLES_KEY, roles);
        }
    }
    setFromLocalStorageToSessionStorageToken() {
        const idToken = localStorage.getItem(AUTH_TOKEN_KEY);        
        if (idToken !== null && !isOpera()) {
            sessionStorage.setItem(AUTH_TOKEN_KEY, idToken);
            const appConfig = localStorage.getItem(AUTH_CONFIG_KEY);
            const roles = localStorage.getItem(AUTH_ROLES_KEY);
            sessionStorage.setItem(AUTH_CONFIG_KEY, appConfig);
            sessionStorage.setItem(AUTH_ROLES_KEY, roles);
        }
    }
    getFromSessionToken() {
        return sessionStorage.getItem(AUTH_TOKEN_KEY);
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        if (!!this.getToken()) {
            try {
                const decoded = decode(this.getToken());
                const appConfig = this.getAppConfig();
                const roles = this.getRoles();
                this.appendAppConfigToProfile(decoded, appConfig);
                this.appendRolesToProfile(decoded, roles);
                return decoded;
            } catch (err) {
                console.log('getProfile', this.getToken(), err);
                return {};
            }
        } else {
            return {};
        }
    }

    appendAppConfigToProfile(profile, appConfig) {
        for (let key in appConfig) {
            profile[key] = appConfig[key];
        }
    }

    appendRolesToProfile(profile, roles) {
        profile.role = roles;
    }

    // getRoles() {
    //     // Using jwt-decode npm package to decode the token
    //     try {
    //         const decoded = decode(this.getToken());
    //         let rolesArray = [];
    //         if (decoded !== undefined && decoded !== null && decoded.role !== undefined && decoded.role !== null) {
    //             decoded.role.forEach((element) => {
    //                 if (element.authority !== undefined && element.authority !== null) {
    //                     rolesArray.push(element.authority);
    //                 }
    //             });
    //         }
    //         return rolesArray;
    //     } catch (err) {
    //         return [];
    //     }
    // }

    isUserInRole(role) {
        const roles = this.getRoles();
        if (roles) {
            return roles.includes(role);
        } else {
            return false;
        }
        
    }

    isUserInAnyRole(...rolesToFind) {
        const roles = this.getRoles();
        if (roles) {
            let authorized = false;
            rolesToFind.forEach((role) => {
                if (roles.includes(role)) {
                    authorized = true;
                }
            });
            return authorized;
        } else {
            return false;
        }        
    }
    

    isUserInAnyRoleArray(rolesToFind) {
        const roles = this.getRoles();
        if (roles) {
            let authorized = false;
            rolesToFind.forEach((role) => {
                if (roles.includes(role)) {
                    authorized = true;
                }
            });
            return authorized;
        } else {
            return false;
        }        
    }

    getUserId() {
        const user = this.getProfile();
        return user.userId ? user.userId : null;
    }
    
    getUserEmail() {
        const user = this.getProfile();
        return user.sub ? user.sub : null;
    }

    expirationTimer() {
        try {
            const decoded = decode(this.getToken());
            let seconds = moment().diff(new Date(decoded.exp * 1000), 'seconds');
            return moment.utc(-seconds * 1000).format('mm:ss');
        } catch (err) {
            this.logout();
        }
    }
}
